import { render, staticRenderFns } from "./project-events.vue?vue&type=template&id=2bad70bc&"
import script from "./project-events.vue?vue&type=script&lang=js&"
export * from "./project-events.vue?vue&type=script&lang=js&"
import style0 from "./project-events.vue?vue&type=style&index=0&id=2bad70bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports